import CommonBanner from "../global-components/common_banner";
import Footer from "../global-components/footer";
import Subscribe from "../global-components/subscribe";
import TopNav from "../global-components/top_nav";
import UserProfileComp from "./UserProfileComp";
import React, { useEffect, useState } from "react";
import encryptStorage from "../../utils/Encryptstorage";
import OliBookingList from "./OliBookingList";
const Userprofile = () => {

  const [agency, setagency] = useState(0)

  const enl = encryptStorage.getItem("enl");
  let login = sessionStorage.getItem("isLoggedIn");

  useEffect(() => {
    //idForReport, loginUser
    if (login == "yes") {
      const userDetail = JSON.parse(enl);
      if (userDetail.b2b == true) {
        setagency(userDetail.agency.agencyId);

      }
    }
  }, []);
  return (
    <>
      <TopNav />
      {
        agency == "1240" ? "" :  <CommonBanner title="Profile Page" />
      }
     
      {
        agency == "1240" ? <div className="user-profile-area pd-top-120">
          <div className="container"><OliBookingList /> </div></div> : <UserProfileComp />
      }
      {/* <UserProfileComp /> */}
      <Subscribe />
      <Footer />
    </>
  );
};

export default Userprofile;
